const fn = document.getElementById('fn').innerText;
const datafile = fn;

async function getData(z) {
  const data = await d3.csv(z);
  return data;
}

let paused = false;

async function processData() {
  const duration = 250;
  const numberOfBarsToDisplay = 10;
  const numberOfInterpolations = 6;
  const width = 900;
  const barSize = 36;
  const margin = ({
    top: 100,
    right: 6,
    bottom: 6,
    left: 0,
  });
  const height = margin.top + barSize * numberOfBarsToDisplay + margin.bottom;
  const formatNumber = d3.format(',.2s');
  const formatMoney = function(d) { return "£" + formatNumber(d); };
  // const formatDate = d3.utcFormat('%b %Y');
  const formatDate = d3.timeFormat('%b %Y');
  const altformatDate = d3.timeFormat('%Y-%m-%d');

  let renderedFrames = 0;

  const data = await getData(datafile);
  const names = new Set(data.map((d) => d.name));

  const datevalues = Array.from(d3.rollup(data, ([d]) => d.cost, (d) => d.valdate, (d) => d.name))
    .map(([valdate, dd]) => [new Date(valdate), dd])
    .sort(([a], [b]) => d3.ascending(a, b));

  function rank(value) {
    const dd = Array.from(names, (name) => ({
      name,
      value: value(name) || 0,
    }));
    dd.sort((a, b) => d3.descending(a.value, b.value));
    for (let i = 0; i < dd.length; i += 1) dd[i].rank = Math.min(numberOfBarsToDisplay, i);
    return dd;
  }

  function getKeyFrames() {
    const keyframes = [];
    let ka;
    let a;
    let kb;
    let b;
    for ([[ka, a], [kb, b]] of d3.pairs(datevalues)) {
      for (let i = 0; i < numberOfInterpolations; i += 1) {
        const t = i / numberOfInterpolations;
        const getVal = (yy) => a.get(yy) * (1 - t) + b.get(yy) * t;
        keyframes.push([new Date(ka * (1 - t) + kb * t), rank(getVal)]);
      }
    }
    keyframes.push([new Date(kb), rank((yy) => b.get(yy) * 1)]);
    return keyframes;
  }
  const keyframes = getKeyFrames();

  const nameframes = d3.groups(keyframes.flatMap(([, ddata]) => ddata), (d) => d.name);
  const prev = new Map(nameframes.flatMap(([, ddata]) => d3.pairs(ddata, (a, b) => [b, a])));
  const next = new Map(nameframes.flatMap(([, ddata]) => d3.pairs(ddata)));
  const x = d3.scaleLinear([0, 1], [margin.left, width - margin.right]);

  const y = d3.scaleBand()
    .domain(d3.range(numberOfBarsToDisplay + 1))
    .rangeRound([margin.top, margin.top + barSize * (numberOfBarsToDisplay + 1 + 0.1)])
    .padding(0.1);


  function getColor() {
    const colors = ['#4E79A7', '#EDC949', '#BAB0AB', '#59A14F', '#F28E2C', '#AF7AA1', '#9E2E53', '#76B7B2', '#9C755F', '#E15759'];
    const yrs = ['2010', '2011', '2012', '2013', '2014', '2015', '2016', '2017', '2018', '2019'];
    // const scale = d3.scaleOrdinal(d3.schemeTableau10);
    const scale = d3.scaleOrdinal()
      .domain(yrs)
      .range(colors);
    if (data.some((d) => d.category !== undefined)) {
      const categoryForName = new Map(data.map((d) => [d.name, d.category]));
      // scale.domain(Array.from(categoryForName.values()).sort());
      // scale.domain(yrs.values);
      return (d) => scale(categoryForName.get(d.name));
    }
    return (d) => scale(d.name);
  }
  const color = getColor();

  function bars(svg) {
    let bar = svg.append('g')
      .attr('fill-opacity', 0.9)
      .selectAll('rect');
    return ([, data1], transition) => bar = bar
      .data(data1.slice(0, numberOfBarsToDisplay), (d) => d.name)
      .join(
        (enter) => enter.append('rect')
          .attr('fill', color)
          .attr('height', y.bandwidth())
          .attr('x', x(0))
          .attr('y', (d) => y((prev.get(d) || d).rank))
          .attr('width', (d) => x((prev.get(d) || d).value) - x(0)),
        (update) => update,
        (exit) => exit.transition(transition).remove()
          .attr('y', (d) => y((next.get(d) || d).rank))
          .attr('width', (d) => x((next.get(d) || d).value) - x(0)),
      )
      .call((bar1) => bar1.transition(transition)
        .attr('y', (d) => y(d.rank))
        .attr('width', (d) => x(d.value) - x(0)));
  }

  function textTween(a, b) {
    const i = d3.interpolateNumber(a, b);
    return function formTxt(t) {
      this.textContent = formatMoney(i(t));
    };
  }
  function labels(svg) {
    let label = svg.append('g')
      .style('font', 'bold 12px sans-serif')
      .style('font-variant-numeric', 'tabular-nums')
      .attr('text-anchor', 'end')
      .selectAll('text');
    return ([, data1], transition) => label = label
      .data(data1.slice(0, numberOfBarsToDisplay), (d) => d.name)
      .join(
        (enter) => enter.append('text')
          .attr('transform', (d) => `translate(${x((prev.get(d) || d).value)},${y((prev.get(d) || d).rank)})`)
          .attr('y', y.bandwidth() / 2)
          .attr('x', -6)
          .attr('dy', '-0.25em')
          .text((d) => d.name)
          .call((text) => text.append('tspan')
            .attr('fill-opacity', 0.7)
            .attr('font-weight', 'normal')
            .attr('x', -6)
            .attr('dy', '1.15em')),
        (update) => update,
        (exit) => exit.transition(transition).remove()
          .attr('transform', (d) => `translate(${x((next.get(d) || d).value)},${y((next.get(d) || d).rank)})`)
          .call((g) => g.select('tspan').tween('text', (d) => textTween(d.value, (next.get(d) || d).value))),
      )
      .call((bar) => bar.transition(transition)
        .attr('transform', (d) => `translate(${x(d.value)},${y(d.rank)})`)
        .call((g) => g.select('tspan').tween('text', (d) => textTween((prev.get(d) || d).value, d.value))));
  }

  function axis(svg) {
    const g = svg.append('g')
      .attr('class', 'axis')
      .attr('transform', `translate(0,${margin.top})`);

    const aaxis = d3.axisTop(x)
      .ticks(width / 160)
      .tickSizeOuter(0)
      .tickSizeInner(-barSize * (numberOfBarsToDisplay + y.padding()));

    return (_, transition) => {
      g.transition(transition).call(aaxis);
      g.select('.tick:first-of-type text').remove();
      g.selectAll('.tick:not(:first-of-type) line').attr('stroke', 'black');
      g.select('.domain').remove();
    };
  }

  function ticker(svg, initialFrame = 0) {
    const now = svg.append('text')
      .style('font', `bold ${barSize}px sans-serif`)
      .style('font-variant-numeric', 'tabular-nums')
      .attr('text-anchor', 'end')
      .attr('x', width / 2)
      // .attr('x', width - 6)
      // .attr('y', margin.top + barSize * (numberOfBarsToDisplay - 0.45))
      .attr('y', margin.top - 60)
      // .attr('dy', '0.5em')
      .text(formatDate(keyframes[initialFrame][0]));

    return ([date], transition) => {
      transition.end().then(() => now.text(formatDate(date)));
    };
  }
  async function plot() {
    if (renderedFrames !== 0) {
      d3.select('svg').remove();
    }
    const svg = d3.select('div#container')
      .append('svg')
      .attr('preserveAspectRatio', 'xMinYMin meet')
      .attr('viewBox', [0, 0, width, height])
      .classed('svg-content', true);

    const updateBars = bars(svg);
    const updateAxis = axis(svg);
    const updateLabels = labels(svg);
    const updateTicker = ticker(svg, renderedFrames);

    svg.node();
    let i = 0;
    for (const keyframe of keyframes) {
      i++;
      if (i < renderedFrames) {
        continue;
      }
      if (paused) {
        return;
      }

      const transition = svg.transition()
        .duration(duration)
        .ease(d3.easeLinear);
      // Extract the value of the top bar - second alt runs with a fixed scale
      x.domain([0, keyframe[1][0].value]);
      // x.domain([0, d3.max(keyframes, ([, data]) => d3.max(data, d => d.value))]);

      updateAxis(keyframe, transition);
      updateBars(keyframe, transition);
      updateLabels(keyframe, transition);
      updateTicker(keyframe, transition);

      await transition.end();
      renderedFrames++;
    }
  }

  function playpause(inputValues, delay) {
    const values = Array.from(inputValues);
    const form = d3.select('.frm').node();
    let timer = null;
    let complete = false;
    stop(complete);

    function start() {
      form.b.textContent = 'Pause';
      timer = setInterval(tick, delay);
      paused = false;
    }

    function stop(stat) {
      if (stat) {
        form.b.textContent = 'Restart';
        renderedFrames = 0;
        complete = false;
      } else {
        form.b.textContent = 'Play';
      }
      clearInterval(timer);
      timer = null;
      paused = true;
    }

    function tick() {
      const endOfValues = values.length;
      if (renderedFrames === endOfValues) {
        complete = true;
        return stop(complete);
      }
    }

    form.b.onclick = () => {
      if (timer) return stop(complete);
      start();
      plot();
    };
  }

  plot();
  playpause(keyframes, duration);
}
processData();
